import { create } from 'zustand';

export interface ReportListItem {
    text: string;
    price: number;
    min: number;
    max: number;
    info: string;
    lock: boolean;
    vat: number;
    email: string;
}

export interface ReportData {
    id: number;
    title: string;
    invoiceDate: string; // dd.mm.yyyy
    datumVon: string; // dd.mm.yyyy
    datumBis: string; // dd.mm.yyyy
    list: ReportListItem[];
}

interface ReportState {
    report: ReportData | null;
    refreshVersion: number;
}

interface ReportActions {
    setReport: (report: ReportData) => void;
    getReport: () => ReportData | null;
    reset: () => void;
    bumpRefresh: () => void;
}

type ReportStore = ReportState & ReportActions;

export const useReportStore = create<ReportStore>((set, get) => ({
    report: null,
    refreshVersion: 0,

    setReport: (report) => set({ report }),
    getReport: () => get().report,
    reset: () => set({ report: null }),
    bumpRefresh: () => set((state) => ({ refreshVersion: state.refreshVersion + 1 })),
}));


